import { GeoPoint } from './geo-point';
var City = /** @class */ (function () {
    function City(inputData) {
        var data = inputData || {};
        this.cityPlaceId = data['cityPlaceId'];
        this.address = data['address'];
        this.city = data['city'];
        this.zipCode = data['zipCode'];
        this.department = data['department'];
        this.departmentShort = data['departmentShort'];
        this.state = data['state'];
        this.stateShort = data['stateShort'];
        this.country = data['country'];
        this.countryShort = data['countryShort'];
        this.geo = new GeoPoint(data['geo']);
        this.type = data['type'];
    }
    Object.defineProperty(City.prototype, "short", {
        /**
         * Print city. Format is one of these (depending of priority) :
         * - Priority 01: city, department
         * - Priority 02: city, country
         * - Priority 03: city
         * - Priority 04: department, country
         * - Priority 05: department
         * - Priority 06: country
         *
         * PS: priority is use when data is not set. For example, in school model,
         * location property isn't always fully set. The city, the department or/and
         * the country can be missed. It is also the case when the location is out of
         * France.
         */
        get: function () {
            if (this.city) {
                var tmp = this.city === this.department ? this.country : this.department || this.country || '';
                return "" + this.city + (tmp ? ', ' : '') + tmp;
            }
            if (this.department) {
                return "" + this.department + (this.country ? ', ' : '') + this.department;
            }
            return this.country;
        },
        enumerable: true,
        configurable: true
    });
    return City;
}());
export { City };
//# sourceMappingURL=city.js.map